var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.$store.state.toolIds.includes(_vm.project.gisWeb.id) &&
      _vm.gisWeb &&
      _vm.project.gisWeb.active
  )?_c('div',{staticClass:"iframe-container"},[_c('fullscreen-btn',{attrs:{"element-id":"gis-web"}}),(_vm.gisWeb && _vm.perspective.path)?_c('iframe',{attrs:{"id":"gis-web","src":("" + (_vm.$store.state.dataHost) + (_vm.perspective.path))}}):_vm._e()],1):(!_vm.$store.state.toolIds.includes(_vm.project.gisWeb.id))?_c('not-permitted'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }